import { Navigate, Outlet, useLocation } from 'react-router';
import { isAuthenticated, getUser } from '../lib/auth';

interface ProtectedRouteProps {
  allowedRoles?: string[];
}

export function ProtectedRoute({ allowedRoles }: ProtectedRouteProps) {
  const location = useLocation();
  const authenticated = isAuthenticated();
  const user = getUser();

  if (!authenticated) {
    // Redirect to login, save intended destination
    const isAdminRoute = location.pathname.startsWith('/admin');
    return <Navigate to={isAdminRoute ? '/admin/login' : '/login'} replace state={{ from: location }} />;
  }

  if (allowedRoles && user?.role && !allowedRoles.includes(user.role)) {
    // User doesn't have required role
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
